import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Section } from './ui/Section';
export function BeforeAfter() {
  const rows = [{
    before: 'Pan industrial que se desmigaja',
    after: 'Pan artesano con crujido real'
  }, {
    before: 'Pasta blanda sin textura',
    after: 'Carbonara que engaña al paladar'
  }, {
    before: 'Domingo con ansiedad por la semana',
    after: '21 comidas resueltas de antemano'
  }, {
    before: 'Vergüenza en restaurantes y bodas',
    after: 'Pides con seguridad en cualquier sitio'
  }, {
    before: 'Inflamación sin saber la causa',
    after: 'Cuerpo ligero sin pasar hambre'
  }, {
    before: 'Sensación de dieta permanente',
    after: 'Comer como siempre. Sin el gluten.'
  }];
  return <Section variant="alt" data-id="element-31" data-mp="39r4xm6ttrizj">
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-4 text-brand-title" data-id="element-32" data-mp="2vr3x4shh2dkl">
        De prohibir alimentos a saber reemplazarlos
      </h2>
      <p className="text-center text-brand-text font-body mb-10 max-w-xl mx-auto text-sm md:text-base leading-relaxed" data-id="element-33" data-mp="30pnml2v9y7hp">
        Hay una diferencia enorme entre una lista de "no puedes comer esto" y
        un sistema que te enseña qué poner en su lugar.
      </p>

      <div className="max-w-3xl mx-auto rounded-2xl overflow-hidden border border-brand-border shadow-card grid md:grid-cols-2" data-id="element-34" data-mp="172zuh273p5fs">
        <div className="bg-red-50/60 p-5 md:p-7" data-id="element-35" data-mp="1246hdavq7gg5">
          <div className="text-red-500 font-heading font-bold text-xs uppercase tracking-wide mb-4" data-id="element-36" data-mp="edswq5fh0jvl">
            ✕ Sin el sistema
          </div>
          <ul className="space-y-3.5" data-id="element-37" data-mp="9gkd00eoc7s8">
            {rows.map((row, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-38" data-mp="o4dujqnblkdg" data-mpi={i}>
                <XIcon className="w-4 h-4 text-red-400 shrink-0 mt-0.5" data-id="element-39" data-mp="o5ox5n514m2z" />
                <span className="font-body text-brand-text text-sm leading-snug" data-id="element-40" data-mp="jbkqz63l8i2y">
                  {row.before}
                </span>
              </li>)}
          </ul>
        </div>
        <div className="bg-brand-primaryLight p-5 md:p-7 border-t md:border-t-0 md:border-l border-brand-border" data-id="element-41" data-mp="3msuex1otljio">
          <div className="text-brand-primary font-heading font-bold text-xs uppercase tracking-wide mb-4" data-id="element-42" data-mp="1qq7vffxqj5we">
            ✓ Con Mimetismo Nutricional™
          </div>
          <ul className="space-y-3.5" data-id="element-43" data-mp="20g0z7urmygq3">
            {rows.map((row, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-44" data-mp="20iwutcg0gtbd" data-mpi={i}>
                <CheckIcon className="w-4 h-4 text-brand-primary shrink-0 mt-0.5" data-id="element-45" data-mp="24gumqn161tig" />
                <span className="font-body text-brand-title text-sm leading-snug font-medium" data-id="element-46" data-mp="17swzo5bbaulp">
                  {row.after}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}